// extracted by mini-css-extract-plugin
export var currentItem = "select-module--current-item--A945U";
export var dropdown = "select-module--dropdown--5HXx5";
export var expandButton = "select-module--expand-button--xytXO";
export var item = "select-module--item--W3aRD";
export var selectCurrentItemWrapper = "select-module--select-current-item-wrapper--mxz8Y";
export var selectWrapper = "select-module--select-wrapper--v+C86";